module.exports = __webpack_public_path__ + "img/aryeh.fe3e0c44.png";